import React, { createRef } from 'react';
import { connect } from 'react-redux';
import Menu from '../menu';
import { Button, Input, Pagination, Table } from '../../components';
import { axios, Colors, Globals } from '../../utils';
import LeftArrowIcon from '../../assets/icons/left-arrow.png';

const STATUS = {
  PENDING: 0,
  IN_PROGRESS: 1,
  FINISHED: 2,
};

const STEP = {
  ORDERS: 1,
  DRIVER: 2,
}

class CreateDispatchRoutes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: STEP.ORDERS,
      isEditing: !!this.props.match.params.id,
      dispatch: null,
      form: {
        user_id: this.props.user.id,
        route_id: null,
        driver: '',
        dni: '',
        vehicle: '',
        plate: '',
        description: '',
        status: STATUS.PENDING,
        zones: [],
        orders: [],
      },
      form1: {
        admin_id: this.props.user.admin_id != null ? this.props.user.admin_id : this.props.user.id,
        user_id: this.props.user.id,
        order_id: '',
        dispatch_routes: true,
        page: 1,
        last_page: 1,
        status: 1, // Solo ordenes procesadas
      },
      form2: {
        admin_id: this.props.user.admin_id != null ? this.props.user.admin_id : this.props.user.id,
        user_id: this.props.user.id,
        search: '',
        page: 1,
        last_page: 1,
      },
      data: [],
      zones: [],
    };
  }

  abortController = new AbortController()
  debounce = createRef()

  componentDidMount() {
    this.load();
  }

  componentWillUnmount() {
    this.abortController.abort()
  }

  load = (page = 1) => {
    if (this.props.match.params.id) this.getDispatch();
    this.getOrders(page);
    this.getZones();
  }

  getDispatch = () => {
    const id = this.props.match.params.id;
    const filter = {
      user_id: this.props.user.id,
      correlative_number: id,
    };

    axios
      .post('admin/dispatchroute?page=1', filter)
      .then(res => {
        const dispatch = res.data.data.data?.find(x => x.number_format === id);
        if (!dispatch) {
          Globals.showError('No se ha encontró la guía');
          return this.props.history.push('/dispatch-routes');
        };

        if (dispatch.status !== STATUS.PENDING) {
          Globals.showError('La guía debe estar pendiente para poder editarla');
          return this.props.history.push('/dispatch-routes');
        }

        this.setState(s => ({
          dispatch,
          form: {
            ...s.form,
            user_id: this.props.user.id,
            route_id: dispatch.id,
            driver: dispatch.driver,
            dni: dispatch.dni,
            vehicle: dispatch.vehicle,
            plate: dispatch.plate,
            status: STATUS.PENDING,
            zones: dispatch.zones?.map(z => z.zone_id) || [],
            orders: dispatch.orders?.map(o => o.order_id) || [],
          },
          orders: dispatch?.orders?.map(o => o.order).concat(s.orders) || [],
        }));
      })
      .catch(() => {
        Globals.showError();
      });
  };

  getOrders = async (page = 1) => {
    Globals.setLoading();

    try {
      const form = { ...this.state.form1, page };
      const res = await axios.post('admin/orders?page=' + page, form);
      let data = res.data.orders.data;

      if (this.state.isEditing) {
        // Agregar las ordenes de la guía actual
        const prevOrders = this.state.dispatch?.orders?.map(o => o.order) || [];
        data = prevOrders.concat(data);
      }

      this.setState(s => ({
        form1: {
          ...s.form1,
          page,
          last_page: res.data.orders.last_page,
        },
        data,
      }));

    } catch (error) {
      console.log(error);
    }

    Globals.quitLoading();
  };

  getZones = async (page = 1) => {
    Globals.setLoading();

    try {
      const form = { ...this.state.form2, page };
      const res = await axios.post('admin/dispatchroute/zones?page=' + page, form);
      this.setState(s => ({
        form2: {
          ...s.form2,
          page,
        },
        zones: res.data.zones,
      }));

    } catch (error) {
      console.log(error);
    }

    Globals.quitLoading();
  };

  getStatus = (status) => {
    switch (status) {
      case STATUS.PENDING:
        return {
          text: "Pendiente",
          color: Colors.red,
        };

      case STATUS.IN_PROGRESS:
        return {
          text: "En tránsito",
          color: Colors.black,
        };

      case STATUS.FINISHED:
        return {
          text: "Finalizada",
          color: Colors.black,
        };

      default:
        return {
          text: "No definido",
          color: Colors.black,
        };
    }
  };

  handleChange = async (value, target, form) => {
    const _form = Globals.copy(this.state[form]);
    _form[target] = value;
    await this.setState({ [form]: _form });

    if (form === 'form1') {
      if (this.debounce.current) clearTimeout(this.debounce.current);
      this.debounce.current = setTimeout(() => this.getOrders(), 800);

    } else if (form === 'form2') {
      if (this.debounce.current) clearTimeout(this.debounce.current);
      this.debounce.current = setTimeout(() => this.getZones(), 800);
    }
  };

  setStep = (step) => {
    this.setState({ step });
  }

  toggleOrder = (item) => {
    const orders = this.state.form.orders.some(id => id === item.id)
      ? this.state.form.orders.filter(id => id !== item.id)
      : this.state.form.orders.concat([item.id]);

    this.setState(s => ({ form: { ...s.form, orders } }));
  };

  toggleZone = (item) => {
    const zones = this.state.form.zones.some(id => id === item.id)
      ? this.state.form.zones.filter(id => id !== item.id)
      : this.state.form.zones.concat([item.id]);

    this.setState(s => ({ form: { ...s.form, zones } }));
  };

  isValidForm = (showError = true) => {
    const onError = (msg) => {
      if (showError) Globals.showError(msg);
      return false;
    };

    if (this.state.step === STEP.ORDERS) {
      if (!this.state.form.zones.length)
        return onError('Debe seleccionar al menos una zona');

      if (!this.state.form.orders.length)
        return onError('Debe seleccionar al menos un pedido');
    }

    if (this.state.step === STEP.DRIVER) {
      const hasDriverName = !!this.state.form.driver;

      if (hasDriverName && !this.state.form.dni)
        return onError('Debe indicar la identificación del conductor');

      if (hasDriverName && !this.state.form.vehicle)
        return onError('Debe indicar el vehículo');

      if (hasDriverName && !this.state.form.plate)
        return onError('Debe indicar la placa del vechículo');
    }

    return true;
  };

  submit = async () => {
    if (!this.isValidForm()) return;

    if (this.state.step === STEP.ORDERS)
      return this.setStep(STEP.DRIVER);

    Globals.setLoading();

    try {
      const res = await axios.post('admin/dispatchroute/create', this.state.form);
      if (res.data.result) {
        Globals.showSuccess(res.data.message);
        this.props.history.push('/dispatch-routes');
      } else {
        Globals.showError();
      }

    } catch (error) {
      Globals.showError(error?.message);
    }

    Globals.quitLoading();
  };

  render() {
    const { history } = this.props;
    const { data } = this.state;
    const isSaveBtnEnabled = this.isValidForm(false);

    if (this.state.step === STEP.DRIVER) return (
      <Menu
        history={history}
        leftSlot={<BackButton onClick={() => this.setStep(STEP.ORDERS)} />}
      >
        <div id="dispatch-routes-create">
          <section id="driver">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <p className="section">Datos del conductor y vehículo</p>
                <p className="tip">Estos datos son opcionales, si no lo va a utilizar presione Finalizar</p>
              </div>
              <div>
                <Button
                  style={{ padding: '0.5rem 1rem', borderRadius: '8px' }}
                  disabled={!isSaveBtnEnabled}
                  onClick={this.submit}
                >
                  Finalizar
                </Button>
              </div>
            </div>

            <form onSubmit={this.submit}>
              <Input
                color=" "
                label="Nombre Conductor"
                className="filter"
                labelClass="filter"
                value={this.state.form.driver}
                onChange={e => this.handleChange(e.target.value, 'driver', 'form')}
              />
              <Input
                color=" "
                label="Identificación"
                className="filter"
                labelClass="filter"
                value={this.state.form.dni}
                onChange={e => this.handleChange(e.target.value, 'dni', 'form')}
              />
              <Input
                color=" "
                label="Vehículo"
                className="filter"
                labelClass="filter"
                value={this.state.form.vehicle}
                onChange={e => this.handleChange(e.target.value, 'vehicle', 'form')}
              />
              <Input
                color=" "
                label="Placa"
                className="filter"
                labelClass="filter"
                value={this.state.form.plate}
                onChange={e => this.handleChange(e.target.value, 'plate', 'form')}
              />
            </form>

            <p className="counter">Cantidad de Zonas incluidas en el envío: <span>{ this.state.form.zones.length }</span></p>
            <p className="counter">Cantidad de Pedidos incluidos: <span>{ this.state.form.orders.length }</span></p>
          </section>
        </div>
      </Menu>
    );

    return (
      <Menu
        history={history}
        leftSlot={<BackButton onClick={() => this.props.history.replace('/dispatch-routes')} />}
      >
        <div id="dispatch-routes-create">
          <section id="orders">
            <section id="routes">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <p className="section">Indica las zonas de despacho que se van a incluir en este envío</p>
                  <p className="tip">Puedes elegir una o muchas zonas en un mismo envío</p>
                </div>
                <div>
                  <Button
                    style={{ padding: '0.5rem 1rem', borderRadius: '8px' }}
                    disabled={!isSaveBtnEnabled}
                    onClick={this.submit}
                  >
                    Continuar
                  </Button>
                </div>
              </div>
              {/* <Input
                color=" "
                name="id"
                className="filter"
                placeholder="Buscar ruta"
                value={this.state.form2.search}
                onChange={e => this.handleChange(e.target.value, 'search', 'form2')}
              /> */}

              <div className="routes">
                <div className="route-list">
                  {this.state.zones.map((item, index) => {
                    const isSelected = this.state.form.zones.some(id => id === item.id);
                    return (
                      <div
                        key={index}
                        className="route-item"
                        data-selected={String(isSelected)}
                        onClick={() => this.toggleZone(item)}
                      >
                        <p>{ item.name }</p>
                      </div>
                    );
                  })}
                </div>

                {!this.state.zones.length && (
                  <p className="no-items">No hay registros</p>
                )}
              </div>

              <div className="actions">
                <Pagination
                  pages={this.state.form2.last_page}
                  active={this.state.form2.page}
                  onChange={page => this.getZones(page)}
                />
              </div>
            </section>

            <Table
              header={['N° de pedido','Cliente','Monto']}
              data={data.length}
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <p className="section">Seleccione los pedidos a incluir en la Guía</p>
                  <Input
                    color=" "
                    name="id"
                    className="filter"
                    placeholder="N° de pedido"
                    value={this.state.form1.order_id}
                    onChange={e => this.handleChange(e.target.value, 'order_id', 'form1')}
                  />
                </div>
              }
            >
              {data.map((item, index) => {
                // const status = this.getStatus(item.status);
                const isCurrent = this.state.dispatch?.orders?.some(order => order.order_id === item.id) || false;
                const isSelected = this.state.form.orders.some(id => id === item.id);
                return (
                  <tr key={index} data-is-current={String(isCurrent)}>
                    <td>
                      <button
                        className={`checkbox ${isSelected ? 'checked' : ''}`}
                        onClick={() => this.toggleOrder(item)}
                      />
                      <span>{item.number_format}</span>
                    </td>
                    <td>{item.client?.name ?? '-'}</td>
                    <td>{Globals.formatMiles(item.total)}</td>
                  </tr>
                );
              })}
            </Table>

            <Pagination
              pages={this.state.form1.last_page}
              active={this.state.form1.page}
              onChange={page => this.load(page)}
            />
          </section>
        </div>
      </Menu>
    );
  }
}

const BackButton = ({ onClick }) => (
  <>
    <div className="back-button">
      <img src={ LeftArrowIcon } onClick={() => onClick()} alt="Regresar" />
    </div>
    <div className="content-breadcumbs">
      <div className="title">Asignar pedidos a guía de despacho</div>
    </div>
  </>
);

export default connect(state => {
  return {
    user: state.user
  };
})(CreateDispatchRoutes);
